import React, { FunctionComponent } from "react";

import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import { ELLIPSIS_SX } from "@app/common/styles";

import { Row, StackProps } from "@rui/Stack";

type TagContainerProps = StackProps & {
  sizing?: "compact" | "padded";
  hidden?: boolean;
};

const TagContainerWithRef = React.forwardRef<HTMLDivElement, TagContainerProps>(
  ({ sizing: _s, hidden: _h, ...props }, ref) => <Row {...props} ref={ref} />
);

TagContainerWithRef.displayName = "TagContainerWithRef";

export const TagContainer = styled(TagContainerWithRef)(
  ({ onClick, sizing, hidden }) => ({
    borderRadius: "2px",
    width: "fit-content",
    height: sizing === "padded" ? "26px" : "18px",
    opacity: hidden ? 0.65 : 1,
    padding: sizing === "padded" ? "4px 4px 4px 8px" : "0",
    "&:hover": {
      cursor: onClick ? "pointer" : undefined,
    },
    "& .MuiTypography-root": {
      padding: sizing === "padded" ? "0px 8px 0px 0px" : "1px 4px",
    },
  })
);

export const TagLabel = styled(Typography)(({ theme }) => ({
  padding: "1px 4px",
  fontSize: "0.75rem",
  fontFamily: theme.typography.fontFamilySecondary,
  fontWeight: 500,
  ...ELLIPSIS_SX,
}));

type TagActionProps = IconButtonProps & { kind: "dark" | "light" };

export const TagAction = styled<FunctionComponent<TagActionProps>>(
  ({ kind: _, ...props }) => <IconButton {...props} />
)(({ kind, theme }) => ({
  backgroundColor:
    kind === "dark"
      ? theme.palette.transparent.white[20]
      : theme.palette.transparent.black[8],
  borderRadius: "2px",
  height: "18px",
  width: "18px",
  "& .MuiSvgIcon-root": {
    fontSize: "14px",
    color: "#FFF",
  },
  "&:hover": {
    backgroundColor: theme.palette.shades.negative[50],
    "& .MuiSvgIcon-root": {
      color: theme.palette.error.main,
    },
  },
}));
